// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"7679d940025bd1e2ac5c","883":"9a4c8460733a4c698174"}[chunkId] + ".js";
};